function escapeRegExp(value) {
  return String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

function stripLeadingRichTextTitle(content, title) {
  const source = String(content || '')
  const heading = String(title || '').trim()
  if (!source || !heading) {
    return source
  }
  const pattern = new RegExp(`^\\s*${escapeRegExp(heading)}(?:<br\\s*\\/?>)+`, 'i')
  return source.replace(pattern, '')
}

export {
  stripLeadingRichTextTitle,
}
